import React, {useContext} from 'react';
import {FormattedMessage} from "react-intl";

import SidebarHeadingTitle from "../../../../../SidebarHeadingTitle";
import MyAccountItem from "./components/MyAccountItem";
import SAVItem from "./components/SAVItem";
import DownloadAppItem from "./components/DownloadAppItem";

import {SidebarContext} from "../../../../../../../../SidebarContext";
import LogoutButton from "../../../../../LogoutButton";

function SettingsMenuContent(props) {
    const {currentMember, isMobile} = useContext(SidebarContext);

    if (!currentMember) {
        return null;
    }

    return (
        <div
            style={{...!isMobile && {padding: '12px'}, width: "240px"}}
        >
            <SidebarHeadingTitle>
                <FormattedMessage id='sidebar.profil.setting.title' />
            </SidebarHeadingTitle>
            <MyAccountItem />
            <SAVItem />
            <DownloadAppItem />
            <LogoutButton />
        </div>
    );
}

export default SettingsMenuContent;
